// useSSE.js
import { useState, useEffect, useRef } from 'react';
import { SSEConnectionManager } from './SSEConnectionManager';

export const useSSE = () => {
  const [messages, setMessages] = useState({});
  const [connectionStatus, setConnectionStatus] = useState('disconnected');
  const sseManagerRef = useRef(null);

  useEffect(() => {
    // 初始化SSE管理器
    sseManagerRef.current = new SSEConnectionManager();
    
    // 设置消息处理回调
    sseManagerRef.current.setMessageCallback((data) => {
      setMessages({
        data:data,
        id: Date.now() + Math.random(),
        timestamp: new Date().toISOString()
      });
    });

    // 清理函数
    return () => {
      if (sseManagerRef.current) {
        sseManagerRef.current.disconnect();
      }
    };
  }, []);

  // 发送消息的方法（如果需要）
  const sendMessage = (message) => {
    // 这里可以扩展为通过主连接发送消息到服务器
    console.log('发送消息:', message);
  };

  return {
    messages,
    connectionStatus,
    sendMessage,
    isMaster: sseManagerRef.current?.isMaster || false
  };
};